var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWebcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110.21",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "no webcam") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bebebe}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-45 54.998 55.209)",
    d: "M53.06-20.78h3.87v151.99h-3.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.3 104.19H23.6v-7.71s.16-3.86 3.86-3.86h54a3.86 3.86 0 0 1 3.86 3.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.17 104.19H46.74V86.35s.13-3.86 3.86-3.86h7.71a3.86 3.86 0 0 1 3.86 3.86zM35.37 9.3a22.76 22.76 0 0 0 2.53 3.07 37.38 37.38 0 0 1 33.1 0 23 23 0 0 0 2.53-3.07 41.5 41.5 0 0 0-38.16 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.66 38.19a20.1 20.1 0 0 1 18.8-12.33 20.49 20.49 0 0 1 7.9 39.39l15.56 15.57a41.7 41.7 0 0 0-6.82-72.7 20.44 20.44 0 0 1-16.64 8.6 20.44 20.44 0 0 1-16.64-8.6 40.4 40.4 0 0 0-17.59 14.41zm22.76 28.25a20.48 20.48 0 0 1-24.06-24.07L18 26a41.7 41.7 0 0 0 56.75 56.77z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.24 57.19h.21a10.85 10.85 0 1 0-5.61-20.09 5.42 5.42 0 0 1 1.6-.26 5.5 5.5 0 1 1-5.5 5.5 5.43 5.43 0 0 1 .27-1.61 10.73 10.73 0 0 0-1.61 5.61v.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWebcam);
export default __webpack_public_path__ + "static/media/no_webcam.8f63cf429171a9c294c1f66a8011c7c8.svg";
export { ForwardRef as ReactComponent };